/* eslint-disable no-unused-expressions */
import { HiDocumentAdd } from "react-icons/hi";
import { useNavigate } from "react-router-dom";
import GlobalForm from "../../components/globalForm/GlobalForm";
import { updateData } from "../../hooks/update";
import { apiPath, RoutePath } from "../../utility/Constant";

const ProjectsCreate = () => {
  const { projectsApi } = apiPath;
  const { projectsContent } = RoutePath;
  const navigate = useNavigate();

  const data = [
    {
      elementType: "input",
      label: "Project Title",
      type: "Text",
      name: "project_title",
      required: false,
    },
    // #2
    {
      elementType: "input",
      label: "Company Name",
      type: "Text",
      name: "company_name",
      required: false,
    },
    // #3
    {
      elementType: "input",
      label: "Client Name",
      type: "Text",
      name: "client_name",
      required: false,
    },
    // #4
    {
      elementType: "input",
      label: "Country Name",
      type: "Text",
      name: "country",
      required: false,
    },
    // #5
    {
      elementType: "input",
      label: "Project Time",
      type: "Text",
      name: "project_time",
      required: false,
    },
    {
      elementType: "select",
      label: "Status",
      type: "select",
      name: "status",
      options: ["ongoing", "completed",],
      required: false,
    },
    // {
    //   elementType: "textField",
    //   label: "short description",
    //   type: "Text",
    //   name: "short_description",
    //   required: false,
    // },
    {
      elementType: "textField",
      label: "project description",
      type: "Text",
      name: "project_description",
      required: false,
    },
    {
      elementType: "file",
      label: `banner Image`,
      name: "image_link",
      type: "file",
      fullCol: true,
      required: false,
    },
  ];

  const update = async (data) => {
    const { image_link, ...rest } = data;
    rest.image_link = {
      url: image_link,
    };
    rest.type = "content";
    rest.identifier = data.project_title;

    const res = await updateData(projectsApi, rest, null, true);
    if (res?.length > 0) {
      setTimeout(() => {
        window.location.href = "/" + projectsContent;
      }, 600);

    }
  };

  return (
    <div>
      <h1 className="font-oswald font-bold text-2xl  uppercase pl-8">
        <HiDocumentAdd className="inline w-7 h-7 mb-1" /> Add new ongoing
        project
      </h1>
      <GlobalForm data={data} update={update} />
    </div>
  );
};

export default ProjectsCreate;
